import { useState } from "react";
import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { InfoTip } from "@/components/app/Help";
import { HELP } from "@/lib/help";

export const TECH = ["AWS", "Azure", "GCP", "Snowflake", "Databricks", "PostgreSQL", "MySQL", "SQL Server", "MongoDB", "Oracle", "Salesforce", "HubSpot", "ServiceNow", "Microsoft 365", "Google Workspace", "Okta", "Microsoft Entra ID", "SIEM", "DLP", "Data catalogues"];

export const parseTech = (s) => { const seen = new Set(); return s.split(",").map((x) => x.trim().replace(/\s+/g, " ")).filter((x) => x && !seen.has(x.toLowerCase()) && seen.add(x.toLowerCase())); };

const Chip = ({ on, onClick, children, id }) => (
  <button type="button" onClick={onClick} data-testid={id} aria-pressed={on}
    className={`flex items-center gap-2 rounded-md border px-3 py-2 text-left text-sm transition-colors ${on ? "border-blue-500 bg-blue-50 text-blue-800" : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"}`}>
    <span className={`grid h-4 w-4 place-items-center rounded border ${on ? "border-blue-600 bg-blue-600" : "border-slate-300"}`}>{on && <Check className="h-3 w-3 text-white" />}</span>{children}
  </button>
);

export function TechPicker({ value = [], other = [], onChange }) {
  const [othersOn, setOthersOn] = useState(other.length > 0);
  const [text, setText] = useState(other.join(", "));
  const toggle = (t) => onChange({ technologies: value.includes(t) ? value.filter((x) => x !== t) : [...value, t], other_technologies: othersOn ? parseTech(text) : [] });
  const toggleOthers = () => {
    if (othersOn && parseTech(text).length && !window.confirm("Remove the custom technologies you entered?")) return;
    const on = !othersOn;
    setOthersOn(on);
    if (!on) setText("");
    onChange({ technologies: value, other_technologies: on ? parseTech(text) : [] });
  };
  return (
    <div className="space-y-3" data-testid="tech-picker">
      <p className="flex items-center gap-1 text-xs text-slate-500">{HELP.technologies.text} <InfoTip text={HELP.technologies.text} example={HELP.technologies.example} testId="tech-help" /></p>
      <div className="grid gap-2 sm:grid-cols-3">
        {TECH.map((t) => <Chip key={t} id={`onb-tech-${t.replace(/\W+/g, "-").toLowerCase()}`} on={value.includes(t)} onClick={() => toggle(t)}>{t}</Chip>)}
        <Chip id="onb-tech-others" on={othersOn} onClick={toggleOthers}>Others</Chip>
      </div>
      {othersOn && (
        <div className="space-y-1">
          <Label htmlFor="other-tech" className="text-xs">Specify other technologies (comma-separated)</Label>
          <Input id="other-tech" value={text} placeholder="e.g., Oracle, MongoDB, Databricks, Custom APIs" data-testid="onb-tech-others-input"
            onChange={(e) => { setText(e.target.value); onChange({ technologies: value, other_technologies: parseTech(e.target.value) }); }} />
          {parseTech(text).length > 0 && <div className="flex flex-wrap gap-1" data-testid="onb-tech-others-preview">{parseTech(text).map((x) => <span key={x} className="rounded bg-slate-100 px-2 py-0.5 text-[11px] text-slate-700">{x}</span>)}</div>}
        </div>
      )}
    </div>
  );
}
